import React, { Fragment } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import classnames from 'classnames'
import logout from '../../admin/actions/logout'
import { i18n } from '../../validator'
const userDefaultLogo = '/images/man-silhouette.svg'
import Button from '../../front/components/shared/sn-button'
import SnIcon from '../../front/components/shared/sn-icon'
import Configurator from '../../configurator'
import { ImageResized } from '../shared/webp-image-resized'
import Link from '../../front/components/shared/sn-link'

@i18n()
export default class Dropdown extends Configurator {
    state = {
        showElements: false,
    }

    toggleShowElements = (closeWholeMenu, forceStatus = null) => {
        const showElements = forceStatus !== null ? forceStatus : !this.state.showElements

        this.setState({ showElements: showElements })

        if (!showElements && closeWholeMenu) {
            this.props.toggleResponsiveMenu(false)
        }
    }

    /**
     * Display link
     *
     * @param {string} name
     * @param {string} href
     * @param {boolean} reactLink
     * @param {string} target
     * @return {*}
     */
    renderLink = (name, href, reactLink, target = null) => {
        if (reactLink === false) {
            return (
                <Button
                    className="Navbar__container--links-dropdown-link-in"
                    href={href}
                    target={target}
                >
                    {name}
                </Button>
            )
        }

        return (
            <Link className="Navbar__container--links-dropdown-link-in" to={href}>
                {name}
            </Link>
        )
    }

    /**
     * Display menu item
     *
     * @param {Object} element
     * @param {int} index
     * @return {*}
     */
    renderMenuItem = (element, index) => (
        <Fragment key={index}>
            {element.heading &&
                <li className="dropdown__heading">{element.heading}</li>
            }
            <li
                onClick={() => this.toggleShowElements(true)}
                className={element.className}
            >
                {this.renderIcon(element.icon || null, element.additionalIcon || null)}
                {this.renderLink(element.name, element.href, element.reactLink, element.target || null)}
            </li>
        </Fragment>
    )

    /**
     * Display link icon
     *
     * @param {string} icon
     * @param {string} additionalIcon
     * @returns {null|*}
     */
    renderIcon = (icon, additionalIcon) => {
        if (icon && !(['circle-ostrava', 'circle-olomouc', 'circle-cheb'].includes(icon))) {
            return (
                <div className="dropdown__icon">
                    <SnIcon className={classnames({
                        'sn-sm': true,
                        [icon]: !!icon,
                    })}
                    />
                    <SnIcon className={classnames({
                        'dropdown__icon__small sn-sm': true,
                        'sn-manage text-color-accent': additionalIcon === 'sn-manage',
                        'sn-circle-plus text-color-brand': additionalIcon === 'sn-circle-plus',
                        'sn-avatar text-color-neutral': additionalIcon === 'sn-avatar',
                    })}
                    />
                </div>
            )
        }

        if (icon && (['circle-ostrava', 'circle-olomouc', 'circle-cheb'].includes(icon))) {
            return (
                <div className={classnames({
                    'dropdown__icon circle': true,
                    [icon]: !!icon,
                })}
                />
            )
        }

        return null
    }

    /**
     * Render profile icon and link
     *
     * @returns {*}
     */
    renderNavbarProfileContainer = () => {
        const {
            authedUser,
            renderShortSurname,
        } = this.props

        const profileUrl = `https://www.sportnect.com/users/${authedUser?.slug}`

        return (
            <li className="Navbar__container--profile">
                <div className="Navbar__container--profile-img">
                    {this.config.REACT_APP_SYSTEM === 'sportnect' &&
                        <Link to={`/users/${authedUser?.slug}`}>
                            <ImageResized
                                src={authedUser?.image?.data?.path}
                                defaultSrc={userDefaultLogo}
                                alt="profile"
                                size="avatar"
                            />
                        </Link>
                    }
                    {this.config.REACT_APP_SYSTEM !== 'sportnect' &&
                        <Button
                            href={profileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <ImageResized
                                src={authedUser?.image?.data?.path}
                                defaultSrc={userDefaultLogo}
                                alt="profile"
                                size="avatar"
                            />
                        </Button>
                    }
                </div>
                <div className="Navbar__container--profile-links">
                    {this.config.REACT_APP_SYSTEM === 'sportnect' &&
                        <Link
                            to={`/users/${authedUser?.slug}`}
                            className="Navbar__container--profile-links-name"
                        >
                            {`${authedUser.name} ${renderShortSurname(authedUser.surname)}.`}
                        </Link>
                    }

                    {this.config.REACT_APP_SYSTEM !== 'sportnect' &&
                        <Button
                            href={profileUrl}
                            className="Navbar__container--profile-links-name"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {`${authedUser.name} ${renderShortSurname(authedUser.surname)}.`}
                        </Button>
                    }
                </div>
            </li>
        )
    }

    render() {
        const {
            className,
            authedUser,
            mainLink,
            elements,
            containerClassname,
            customClassname,
            iconClassname,
            forceActive,
            isResponsiveMenu,
            showResponsive,
            citiesElements,
            t,
            withLogout,
            familyElements,
        } = this.props

        const { showElements } = this.state

        return (
            <OutsideClickHandler
                onOutsideClick={() => this.toggleShowElements(true, false)}
            >
                <li
                    className={classnames({
                        'Navbar__container--links-dropdown': true,
                        'Navbar__container--links-dropdown-active': (isResponsiveMenu && showResponsive) || (showElements || forceActive === true),
                        'Navbar__container--links-dropdown-actived': (isResponsiveMenu && showResponsive) || showElements,
                        [containerClassname]: !!containerClassname,
                    })}
                    onClick={() => this.toggleShowElements(false)}
                >
                    {iconClassname &&
                        <Fragment>
                            <SnIcon className={classnames({
                                [iconClassname]: !!iconClassname,
                            })} />
                            <p>{mainLink}</p>
                        </Fragment>
                    }

                    {!iconClassname &&
                        <span
                            className={classnames({
                                'Navbar__container--links-link': !className,
                                [customClassname]: !className && !!customClassname,
                                [className]: !!className,
                            })}
                        >
                            {mainLink}
                        </span>
                    }

                    {((isResponsiveMenu && showResponsive) || showElements) &&
                        <ul
                            className={classnames({
                                'Navbar__container--links-dropdown-submenu dropdown__submenu': true,
                                [`dropdown__${customClassname}`]: customClassname,
                            })}
                        >
                            {authedUser &&
                                this.renderNavbarProfileContainer()
                            }
                            {elements.map((element, index) => (
                                this.renderMenuItem(element, index)
                            ))
                            }
                            {withLogout &&
                                <li>
                                    <div className="dropdown__icon">
                                        <SnIcon className="sn-logout sn-sm ml-1"/>
                                    </div>
                                    <a className="Navbar__container--links-dropdown-link-in" onClick={() => logout()}>
                                        {t('logout')}
                                    </a>
                                </li>
                            }
                            {familyElements && familyElements?.map?.((element, index) => (
                                this.renderMenuItem(element, index)
                            ))}
                            {citiesElements && citiesElements.map((element, index) => (
                                this.renderMenuItem(element, index)
                            ))
                            }
                        </ul>
                    }
                </li>
            </OutsideClickHandler>
        )
    }
}
